import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// components
import Button from 'components/backoffice/buttonCustom';
import SpinnerComponent from 'components/backoffice/SpinnerComponent';

const FooterModal = ({ onCancel, onSave, onDelete, loading, disabled = false, saveMsg }) => {
  const { t } = useTranslation(['backoffice']);

  return (
    <>
      <Button color={'terciary'} onClick={onCancel} loading={loading}>
        {t('cancel')}
      </Button>
      {onSave && (
        <Button variant="secondary" color={'primary'} onClick={onSave} disabled={disabled}>
          {saveMsg || t('save')}
          <SpinnerComponent loading={loading} />
        </Button>
      )}
      {onDelete && (
        <Button color={'secondary'} onClick={onDelete} loading={loading}>
          {t('eliminar')}
        </Button>
      )}
    </>
  );
};

FooterModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  loading: PropTypes.bool,
  disable: PropTypes.bool,
  saveMsg: PropTypes.string
};

export default FooterModal;
